import o from "react";
const e = () => {
  const l = o.useCallback(() => {
      document.body.style.overflow = "hidden";
    }, []),
    c = o.useCallback(() => {
      document.body.style.overflow = "";
    }, []);
  return {
    lockScroll: l,
    unlockScroll: c
  };
};
export { e as useScrollLock };